module.exports = __webpack_public_path__ + "img/banner-chatbow-webinar.769ca083.png";